module.exports = __webpack_public_path__ + "img/20200609_132445.3cfc2cfa.jpg";